import React, { useState, useEffect } from 'react';

import { DownWhiteArrowIcon } from '../../../assets';
import { CampaignByIdLeadsProps } from './campaignModels';
import { getLeadsByCampaignId } from '../../../core/requests/requests';
import { LeadsListProps } from '../../../core/types/_models';
import CampaignByIdLeadCard from './CampaignByIdLeadCard';
import { PaginationConfigProps } from '../../../components/Pagination/paginationModels';
import Pagination from '../../../components/Pagination/Pagination';

const CampaignByIdLeads: React.FC<CampaignByIdLeadsProps> = ({
  currentCampaignId,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [connectedToCampaignLeads, setConnectedToCampaignLeads] = useState<
    LeadsListProps[]
  >([]);

  const [paginationConfig, setPaginationConfig] =
    useState<PaginationConfigProps>({
      currentPage: 1,
      itemsPerPage: 10,
    });
  const handleTriggerExpand = () => {
    setIsExpanded(!isExpanded);
  };
  const fetchConnectedToCampaignLeads = async () => {
    if (currentCampaignId) {
      try {
        const { data } = await getLeadsByCampaignId(currentCampaignId);
        if (data) {
          // Remove duplicates by id
          const uniqueLeads: LeadsListProps[] = Array.from(
            data
              .reduce(
                (map: Map<string, LeadsListProps>, obj: LeadsListProps) =>
                  map.set(obj.id, obj),
                new Map<string, LeadsListProps>()
              )
              .values()
          );

          setConnectedToCampaignLeads(uniqueLeads);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  useEffect(() => {
    if (currentCampaignId) {
      fetchConnectedToCampaignLeads();
    }
  }, [currentCampaignId]);

  const totalPaginationPages = Math.ceil(
    (connectedToCampaignLeads?.length || 1) / paginationConfig?.itemsPerPage
  );

  // Calculate pagination
  const indexOfLastLead =
    paginationConfig?.currentPage * paginationConfig?.itemsPerPage;
  const indexOfFirstLead = indexOfLastLead - paginationConfig?.itemsPerPage + 1;
  const paginatedLeads = connectedToCampaignLeads?.slice(
    indexOfFirstLead - 1,
    indexOfLastLead
  );

  return (
    <div className="campaign-by-id__leads-container">
      <span className="campaign-by-id__leads-title">{`Leads (${connectedToCampaignLeads?.length})`}</span>
      <div className="campaign-by-id__leads-list">
        {(paginatedLeads?.length > 2 && !isExpanded
          ? paginatedLeads.slice(0, 2)
          : paginatedLeads
        ).map((lead) => (
          <CampaignByIdLeadCard
            key={lead.id}
            lead={lead}
            refetchLeads={fetchConnectedToCampaignLeads}
          />
        ))}
        {totalPaginationPages > 1 && isExpanded && (
          <div className="d-flex-row w-100 p-1rem-0">
            <Pagination
              paginationConfig={paginationConfig}
              setPaginationConfig={setPaginationConfig}
              totalPaginationPages={totalPaginationPages}
              totalItems={connectedToCampaignLeads.length}
            />
          </div>
        )}
      </div>
      {connectedToCampaignLeads?.length > 2 && (
        <div className="campaign-by-id__leads-bottom">
          <button
            className="campaign-by-id__leads-show-more-button"
            onClick={handleTriggerExpand}
          >
            <span className="campaign-by-id__leads-show-more-button-label">
              {isExpanded ? 'Hide' : 'See more'}
            </span>
            <div
              className={`${isExpanded ? 'rotated' : ''} campaign-by-id__leads-show-more-button-icon`}
            >
              <DownWhiteArrowIcon />
            </div>
          </button>
        </div>
      )}
    </div>
  );
};

export default CampaignByIdLeads;
